import React, { Component } from "react";
import { Route, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { jwtRefresh } from "./store/actions/JWTActions";
import { refreshTokenIntervalID } from "./store/actions/UserActions";

import RootComponent from "./containers/homepage/RootComponent";
import BasicProject from "./containers/BasicProject";
import LayoutExport from "./containers/typo/LayoutExport";
import Project from "./containers/project/Project";
import Admin from "./administration/Administration";
import Login from "./containers/Login";
import InitProgress from "./containers/InitProgress";
import SelectTeam from "./containers/SelectTeam";
import Preload from "./containers/preload/Preload";
import ReloginHOC from "./HOC/ReloginHOC";

// Import CSS files
import "./css/grid_styles.css";
import "./css/resizable_styles.css";
import "./css/react-draft-wysiwyg.css";

class App extends Component {
  componentDidMount() {
    //  SetInterval for the refresh of the token
    const refresh_token_interval = setInterval(() => {
      if (this.props.jwt.jwt_token) {
        sessionStorage.setItem(
          "time",
          parseInt(sessionStorage.getItem("time"), 10) + 1 || 1
        );
        if (sessionStorage.getItem("time") % 60 === 0) {
          this.props.refresh(window.env.RefreshJWT);
        }
      }
    }, 10000);
    this.props.refreshTokenIntervalID(refresh_token_interval)

    this.props.history.listen(location => {
      sessionStorage.setItem("history", location.pathname);
    });
  }

  render() {
    return (
      <div className="full-height">
        <Route exact path="/" render={() => <Redirect to="/home" />} />
        <Route
          path="/home"
          render={() => (
            <ReloginHOC>
              <RootComponent />
            </ReloginHOC>
          )}
        />
        <Route
          path="/project/:projectid?"
          render={() => (
            <ReloginHOC>
              <Project />
            </ReloginHOC>
          )}
        />
        <Route
          path="/basic/:mode?/:projectid?/:chapterid?"
          render={() => (
            <ReloginHOC>
              <BasicProject />
            </ReloginHOC>
          )}
        />
        <Route
          path="/layout/:mode?/:projectid?/:chapterid?"
          render={() => (
            <ReloginHOC>
              <LayoutExport />
            </ReloginHOC>
          )}
        />
        {/* <Route path="/home" component={ReloginModal(RootComponent)} />
        <Route path="/project/:projectid?" component={ReloginModal(Project)} />
        <Route
          path="/basic/:mode?/:projectid?/:chapterid?"
          component={ReloginModal(BasicProject)}
        />
        <Route
          path="/layout/:mode?/:projectid?/:chapterid?"
          component={ReloginModal(LayoutExport)}
        /> */}
        <Route path="/login" render={() => <Login />} />

        <Route
          path="/admin"
          render={() => (
            <ReloginHOC forceUpdate>
              <Admin />
            </ReloginHOC>
          )}
        />
        <Route
          path="/init"
          render={() => (
            <ReloginHOC>
              <InitProgress />
            </ReloginHOC>
          )}
        />
        <Route
          path="/teamselect"
          render={() => (
            <ReloginHOC>
              <SelectTeam />
            </ReloginHOC>
          )}
        />
        <Route
          path="/preload"
          render={() => (
            <ReloginHOC>
              <Preload />
            </ReloginHOC>
          )}
        />

        {/* <Route path="/admin" component={ReloginModal(Admin)} />
        <Route path="/init" component={ReloginModal(InitProgress)} />
        <Route path="/teamselect" component={ReloginModal(SelectTeam)} />
        <Route path="/preload" component={ReloginModal(Preload)} /> */}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    jwt: state.jwt
  };
};

const mapDispatchToProps = dispatch => {
  return {
    refresh: url => dispatch(jwtRefresh(url)),
    refreshTokenIntervalID: id => dispatch(refreshTokenIntervalID(id))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/App.js